import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function CalculatorPage() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const details = state?.details || {};
  const costs = state?.costs || {};

  const safeFloat = (val) => {
    if (val === "") return "";
    let n = parseFloat(val);
    return isNaN(n) || n < 0 ? 0 : n;
  };

  const [inputs, setInputs] = useState({
    edc: "",
    electricityDuty: "",
    dgSet: "",
    powerUnit: "",
    perUnitCost: "",
    sales1: "",
    sales2: "",
    sales3: "",
    sales4: "",
    sales5: "",
    sales6: "",
    sales7: "",
    sales8: "",
  });

  const selectedFCI = state?.selectedFCI || 0;
  
  const handleChange = (field, value) => {
    setInputs((prev) => ({
      ...prev,
      [field]: safeFloat(value),
    }));
  };

  return (
    <div className="max-w-xl mx-auto mt-2 bg-white shadow p-6 rounded">
      <h2 className="text-3xl font-bold mb-4 text-blue-900">
        Calculation Cost
      </h2>

      <table className="w-full border border-gray-300">
        <thead>
          <tr className="bg-blue-200">
            <th colSpan={2} className="border p-3 text-left">Incentive Component</th>
          </tr>
        </thead>

        <tbody>
          {[
            { key: "edc", label: "EDC" },
            { key: "electricityDuty", label: "Electricity Duty" },
            { key: "dgSet", label: "DG Set" },
            { key: "powerUnit", label: "Power Unit" },
            { key: "perUnitCost", label: "Per Unit Cost" },
          ].map((item) => (
            <tr key={item.key}>
              <td className="border p-2">{item.label}</td>
              <td className="border p-2">
                <input
                  type="number"
                  className="border p-1 w-full rounded"
                  value={inputs[item.key]}
                  step="0.1"
                  min="0"
                  onChange={(e) => handleChange(item.key, e.target.value)}
                />
              </td>
            </tr>
          ))}

          <tr>
            <td colSpan={2} className="border p-3 bg-blue-100 font-semibold">
              Sales Values (up to 3 Yr)
            </td>
          </tr>

          {Array.from({ length: 3 }).map((_, index) => {
            const key = `sales${index + 1}`;
            return (
              <tr key={key}>
                <td className="border p-2">Sales Value {index + 1}</td>
                <td className="border p-2">
                  <input
                    type="number"
                    className="border p-1 w-full rounded"
                    value={inputs[key]}
                    step="0.1"
                    min="0"
                    onChange={(e) => handleChange(key, e.target.value)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="mt-6 text-right">
        <button
          onClick={() =>
            navigate("/result", {
              state: { details, costs, inputs , selectedFCI}
            })
          }
          className="bg-blue-800 text-white p-3 rounded font-semibold"
        >
          Calculate
        </button>
      </div>
    </div>
  );
}
